// FeaturedHandymen.js

import React from "react";
import base_url from "../../base_url";

const FeaturedHandymen = ({ handymen }) => {

  
  return (
    <div className="featured-handymen">
      <h4 style={{borderColor:'#005299',backgroundColor:'#005299', borderRadius: '2px', padding: '20px', color:'white'}}>Our Featured Handymen</h4>
      <div className="row" style={{paddingLeft: '10px', paddingRight: '10px'}}>
        {handymen?.map((handymen,index) => (
          <div key={index} className="col-lg-3 col-md-6 mb-4">
            <div className="card h-100 d-flex flex-column" style={{display: 'flex', flexDirection: 'column'}}>
              <img
                src={handymen.userInfo?.profile_picture?handymen.userInfo?.profile_picture:require('../../assets/user-circle.png')}
                className="card-img-top"
                style={{height:'14vw', width:'14vw', objectFit: 'cover', borderRadius:'100%', alignSelf:'center', marginTop:10}}
              />
              {/* <div className="card-body d-flex flex-column" style={{flex: 1, display: 'flex', flexDirection: 'column'}}> */}
              <div className="card-body d-flex flex-column" >
                <h5 className="card-title" style={{textAlign:'center'}}>{handymen.userInfo?.username}</h5>

                <div style={{width: '100%', border: '0px solid #ccc', padding: '10px', display: 'flex', flexWrap: 'wrap', gap: '4px'}} >
                  {handymen.userInfo?.contractorEntity.services?.split(',').map((service, index) => (
                    <span key={index} style={{ fontWeight: 'bold', padding: 2, fontSize: 12, color:'#005299'}}>
                      {service.trim() + (index !== handymen.userInfo?.contractorEntity.services?.split(',').length - 1 ? ',' : '')}
                    </span>
                  ))}
                </div>

                <div style={{flex: 1}} />
                <button className='contactnow-button btn' style={{width:'100%', marginTop:'10px'}} onClick={()=>window.location=`/contractor_profile/${handymen.userId}`}>
                  Contact Now
                </button>
              </div>

            </div>
          </div>
        ))}
      </div>
    </div> 
  );
};

export default FeaturedHandymen;
